import React, { useState } from 'react';
import { Button, Divider, Spinner, ToggleButton, Tooltip, Badge } from '@fluentui/react-components';
import { Add24Filled, ArrowSync20Regular, Payment24Regular, ClipboardCheckmark24Regular, ClipboardArrowRight24Regular, ClipboardClock24Regular } from '@fluentui/react-icons';
import { MdOutlineHideImage } from 'react-icons/md';
import { PractitionerConsumption } from '../../../../../models/Entities/Practitioners/PractitionerConsumption';
import './PractitionerConsumption.Menu.Styles.css';
import { ExportToExcelLink } from '../../../../ExportToExcel/ExportToExcelLink.Component';
import { IConsumptionsFilters } from '../../../../../models/Filters/ConsumptionsFilters';

interface Props {
    Filters: IConsumptionsFilters;
    PractitionerId: string;
    SelectedConsumptions: PractitionerConsumption[];
    isChangingStatus: boolean;
    isAddingConsumption: boolean;
    onRequestUpdate: () => void;
    ChangeStatus: (practitionerId: string, consumptionId: string, status: number, isForAll: boolean) => void;
}

const PractitionerConsumptionMenuComponent = (props: Props) => {
    
    const [isConsumptionFormOpen, setIsConsumptionFormOpen] = useState(false);
    const [enableVisitGrouping, setEnableVisitGrouping] = useState(false);

    const onReloadConsumptions = () => {
        props.onRequestUpdate();
    };

    const onClickMarkAsPaid = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.PractitionerId, element.id, 2, false);
        });
    };
    const onClickMarkToSettled = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.PractitionerId, element.id, 6, false);
        });
    };
    const onClickMarkAsRejected = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.PractitionerId, element.id, 4, false);
        });
    };
    const onClickMarkAsPending = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.PractitionerId, element.id, 0, false);
        });
    };
    const onClickMarkAsIgnored = () => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.PractitionerId, element.id, 5, false);
        });
    };

    return (
        <div className='menuContainer'>
            <Button appearance='primary' icon={props.isAddingConsumption ? <Spinner size="extra-tiny" /> : <Add24Filled />} onClick={() => setIsConsumptionFormOpen(true)}>Agregar Concepto</Button>
            <Button appearance='secondary' onClick={onReloadConsumptions}><ArrowSync20Regular /></Button>
            <Divider vertical={true} />
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <Payment24Regular />} onClick={onClickMarkAsPaid}>Cobrado&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <ClipboardCheckmark24Regular />} onClick={onClickMarkToSettled}>A liquidar&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <ClipboardArrowRight24Regular />} onClick={onClickMarkAsRejected}>Rechazar&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <ClipboardClock24Regular />} onClick={onClickMarkAsPending}>Pendiente&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <Button disabled={props.SelectedConsumptions?.length === 0} appearance='secondary' icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <MdOutlineHideImage />} onClick={onClickMarkAsIgnored}>Ignorar&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}</Button>
            <ExportToExcelLink Filters={props.Filters} entityId={props.PractitionerId} Type='Practitioner' />
        </div>
    );
};

export default PractitionerConsumptionMenuComponent;
